import { useEffect, useRef } from 'react';

/**
 * Подписка на событие, приходящее по сокету.
 *
 * Соединение в приложении одно — его держит виджет уведомлений из auth-user-services
 * (колокольчик в Layout). Живые события он пересылает в window как `anyemp:realtime`
 * ({ event, data }), поэтому страницу можно обновлять по событию, не поднимая второй
 * WebSocket и не опрашивая сервер по таймеру.
 *
 * Обработчик держим в ref: иначе каждая новая функция при рендере пересоздавала
 * бы подписку.
 *
 * @param {string} eventType - тип события, например 'support:ticket:created'
 * @param {Function} handler - что делать при получении
 *
 * @example
 *   useRealtimeEvent('support:ticket:created', () => fetchTickets())
 */
export function useRealtimeEvent(eventType, handler) {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!eventType) return undefined;
    const onRealtime = (e) => {
      if (e.detail?.event !== eventType) return;
      try {
        handlerRef.current?.(e.detail.data || {});
      } catch {
        // подписчик не должен ронять раздачу событий
      }
    };
    window.addEventListener('anyemp:realtime', onRealtime);
    return () => window.removeEventListener('anyemp:realtime', onRealtime);
  }, [eventType]);
}

export default useRealtimeEvent;
